import React from "react";
import { ITeamMemberReservation } from "Services/API/API";
import { ReservationDetailsModalById } from "./ReservationDetailsModalById";
import { ReservationDetailsModalInternal } from "./ReservationDetailsModalInternal";

export interface ReservationDetailsModalProps {
    isOpen: boolean,
    toggle: () => void,
    reservation: ITeamMemberReservation | Guid,
    occurrenceDate?: string,
    container?: string | HTMLElement;
 
    onUpdateReservation: (reservationId?: Guid, occurrenceDate?: string) => void;
    onUpdateReservationList?: () => void
}

export const ReservationDetailsModal: React.FC<ReservationDetailsModalProps> = ({ isOpen, toggle, reservation, occurrenceDate, container, onUpdateReservation, onUpdateReservationList }) => {
    return typeof reservation === "object"
        ? <ReservationDetailsModalInternal isOpen={isOpen} reservation={reservation} container={container} toggle={toggle} onUpdateReservation={onUpdateReservation} onUpdateReservationList={onUpdateReservationList} />
        : <ReservationDetailsModalById isOpen={isOpen} id={reservation} container={container} toggle={toggle} occurrenceDate={occurrenceDate} onUpdateReservation={onUpdateReservation} onUpdateReservationList={onUpdateReservationList} />
}